import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=4f27b2a6&scoped=true"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"
import style0 from "./NewsLetter.vue?vue&type=style&index=0&id=4f27b2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27b2a6",
  null
  
)

export default component.exports